export const CoreRoutes = {
    appUpdate: 'app_update',
    import: 'import',
    empty: 'empty',
    loading: 'loading',
    error: 'error',
    popUp: 'pop_up',
    toast: 'toast',
    pushNotification: 'push_notification',
    notificationsPermissions: 'notifications-permissions',
    share: 'share'
};
